/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import wordOvershootScaleInGif from '../../../assets/images/transitions/wordOvershootScaleIn.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_WORD_OVERSHOOT_SCALE_IN = 'wordOvershootScaleIn';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const wordOvershootScaleInPresetDetails = {
  // The name of the preset.
  name: PRESET_WORD_OVERSHOOT_SCALE_IN,

  // A human friendly name for the preset.
  humanName: 'Word Overshoot Scale In',

  // A preview of the transition.
  gif: wordOvershootScaleInGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'word.scale': {
      time: {
        end: 'start.1595',
        start: 'start.0'
      },
      easing: EASINGS.easeOutBack,
      values: [
        0,
        1
      ],
      immediateRender: true,
      stagger: '200'
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_WORD_OVERSHOOT_SCALE_IN,
    options: {},
  },
};

wordOvershootScaleInPresetDetails.template.options = lodash.cloneDeep(wordOvershootScaleInPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_WORD_OVERSHOOT_SCALE_IN;

// This defines the value of the presets object.
export default wordOvershootScaleInPresetDetails;

